(function () {
  // Restock Rocket adds its own "notify me" button (floating at the screen edge)
  // while the selected variant is sold out and removes it again once it is available.
  // Mirror that: show our button below the sold out button, keep the app's button
  // hidden and forward clicks to it so the app opens its form.
  var appButtonSelector = [
    '.restock-rocket-button-container',
    '.restock-rocket-button-container-float-right',
    '.restock-rocket-button-container-float-left'
  ].join(',');

  var notifyButton = document.querySelector('[data-restock-notify]');
  if (!notifyButton) {
    return;
  }
  var form = notifyButton.closest('form');

  function sync() {
    var appButton = document.querySelector(appButtonSelector);
    if (appButton) {
      appButton.classList.add('hide');
    }
    notifyButton.classList.toggle('hide', !appButton);
    form.classList.toggle('product-single__form--restock', !!appButton);
  }

  notifyButton.addEventListener('click', function () {
    var appButton = document.querySelector(appButtonSelector);
    if (appButton) {
      appButton.querySelector('button').click();
    }
  });

  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync();
})();
